var $bc604a0ada841979$exports = {};
$bc604a0ada841979$exports = {
    "collapse": ` Skupi`,
    "expand": `Pro\u{161}iri`
};


export {$bc604a0ada841979$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
